<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
    .template5wrapper h2 {
        font-size: 1.5rem;
        font-weight: 500;
        text-align: center;
        color: #333333;
        text-transform: none;
    }
    .template5wrapper h3 {
        font-size: 0.875rem;
        font-weight: 500;
        text-align: center;
        color: #7e7885;
        padding: 0.5625rem 0 0 0;
        text-transform: none;
    }
    .template5wrapper h5 {
        font-size: 1.125rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #7e7885;
        margin-top: 1.25rem;
        text-transform: none;
    }
    .template5wrapper h6 {
        font-size: 0.8rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #7e7885;
        margin-top: 1.25rem;
        text-transform: none;
    }
    .answersWrapper {
        margin: 1.875rem 0 0 0;
        display: flex;
        justify-content: space-between;
    }
    @media (max-width: 576px) {
    .answersWrapper {
        flex-wrap: wrap;
        justify-content: center;
    }
}
    .answersWrapper::before {
        content: "";
    }
    .answersWrapper::after {
        content: "";
    }
    .error {
        margin-top: 1.25rem;
        color: red;
        background: transparent;
    }
    .textinput {
        min-width: 5ch;
        width: 5ch;
        text-align: center;
    }
    textarea {
        border: .125rem solid;
        border-radius: .375rem;
    }
</style>

<template>
    <div class="template5wrapper">
        <h2>{{ question.title }}</h2>
        <h3>{{ question.subTitle }}</h3>
        <div class="answersWrapper">
            <input
                v-if="question.type == 'number'"
                v-model="inputValue"
                class="textinput"
                type="text"
                onkeyup="this.style.width = (this.value.length+3) + 'ch';"
            >
            <textarea
                v-else-if="question.type == 'text'"
                v-model="inputValue"
                type="text"
            />
        </div>
        <div>
            <p
                v-show="textError"
                class="error"
            >
                {{ textErrorText }}
            </p>
            <p
                v-show="numberError"
                class="error"
            >
                {{ numberErrorText }}
            </p>
        </div>
        <h5>{{ answers[0].title }}</h5>
        <h6>{{ answers[0].subTitle }}</h6>
    </div>
</template>

<script>
export default {
    name: 'Q5Template',
    data() {
        return {
            inputValue: '',
            numberError: false,
            textError: false
        };
    },
    computed: {
        question: function () {
            return this.$store.state.questionData;
        },
        numberErrorText: function () {
            return this.$store.state.quizData.translations.templateq5numbererror;
        },
        textErrorText: function () {
            return this.$store.state.quizData.translations.templateq5texterror;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        }
    },
    watch: {
        question: function () {
            this.loadInitialValue();
        },
        inputValue: function (val) {
            var textValue = '';
            var avalue = '';
            if (val && val !== '') {
                // input validation for caracters
                if (this.question.type === 'text') {
                    var withoutNumbers = (/[0-9]/g);
                    if (withoutNumbers.test(val)) {
                        this.textError = true;
                        textValue = [this.question.answers[0].id, val];
                        this.$store.commit('setAnswerValue', textValue);
                        this.$store.commit('setNextButtonState', false);
                    } else {
                        this.textError = false;
                        this.$store.commit('setNextButtonState', true);
                    }
                } else {
                    textValue = [this.question.answers[0].id, val];
                    this.$store.commit('setAnswerValue', textValue);
                    this.$store.commit('setNextButtonState', false);
                }
                // input validation for digits
                if (this.question.type === 'number') {
                    var reg = /^\d+$/;
                    if (reg.test(val)) {
                        this.numberError = false;
                        avalue = [this.question.answers[0].id, val];
                        this.$store.commit('setAnswerValue', avalue);
                        this.$store.commit('setNextButtonState', false);
                    } else {
                        this.numberError = true;
                        this.$store.commit('setNextButtonState', true);
                    }
                } else {
                    avalue = [this.question.answers[0].id, val];
                    this.$store.commit('setAnswerValue', avalue);
                    this.$store.commit('setNextButtonState', false);
                }
            } else {
                this.$store.commit('setNextButtonState', true);
            }
        }
    },
    mounted() {
        this.loadInitialValue();
    },
    methods: {
        loadInitialValue() {
            var answerValue = this.question.userAnswer[0] && this.question.userAnswer[0][1] ? this.question.userAnswer[0][1] : '';
            if (answerValue && answerValue !== '') {
                this.inputValue = this.question.userAnswer[0][1];
            } else {
                this.inputValue = '';
            }
        }
    }
};
</script>
